module["exports"] = [
  "com",
  "pl",
  "com.pl",
  "net",
  "org"
];
